document.addEventListener('DOMContentLoaded', function () {
    // Get the select element and the option element
    var selectElement = document.getElementById('input_2_16');
    var optionElement = document.getElementById('choice_2_3_1');
    var selectedOption = document.querySelector('.gf_placeholder');
    var OptionWrap = document.getElementById('input_2_3');

    if (selectElement && optionElement) {

        if (selectedOption?.hasAttribute('selected')) { 
            optionElement.setAttribute('disabled', '');
            // OptionWrap.style.opacity = '0.5';
        }

        // Add an event listener to the select element
        selectElement.addEventListener('change', function () {
            // console.log('select element changed and attribute removed');
            optionElement.removeAttribute('disabled');
            // OptionWrap.style.opacity = '1';
        });
    }
});